@if (!isMobile()) {
    @if (isOpen()) {
        <div class="drawer-backdrop" (click)="close()"></div>
    }

    <div class="drawer-container" [class.open]="isOpen()" [style.width.px]="currentDrawerWidth()">
        <div class="resize-handle" (mousedown)="startResize($event)"></div>

        <div class="drawer-header">
            <div class="drawer-title">
                <img src="assets/icons/desktop/ScoutAI_Desktop_Icon.svg" alt="Scout AI" class="scout-ai-icon-header">
                <span>Navigator-Scout</span>
            </div>
            <div class="drawer-actions">
                <button (click)="popOut()" class="scout-ai-btn-icon" aria-label="Open in new window" title="Open in new window">
                    <i class="fa-solid fa-up-right-from-square"></i>
                </button>
                <button (click)="close()" class="scout-ai-btn-icon" aria-label="Close" title="Close">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
        </div>

        <div class="drawer-content">
            <app-scout-ai-session></app-scout-ai-session>
        </div>
    </div>
}
